<script lang="ts">
    import type {SearchQuery, SortOption} from "../NvbsSearchEngineApi/interfaces";

    let {
        options = [],
        searchStore = $bindable(),
    }: {
        options: SortOption[],
        searchStore: SearchQuery
    } = $props();
</script>

<div class="sort-selector">
    {#if options.length > 0}
    <select bind:value={searchStore.sort} onchange={() => {
        searchStore.page = 1;
    }}>
        <option value="">Sortering</option>
        {#each options as option}
            <option value={option.key}>{option.label}</option>
        {/each}
    </select>
    {/if}
</div>

<style lang="scss">
    .sort-selector {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    select {
        padding: 5px 10px;
        border-radius: 5px;
        border: 1px solid #eee;
    }
</style>

